<template>
  <div class="fixed inset-x-0 top-0 z-50 p-4">
    <transition
      enter-active-class="transform ease-out duration-300 transition"
      enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
      enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
      leave-active-class="transition ease-in duration-100"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden mx-auto"
      >
        <div class="p-4">
          <div class="flex items-start">
            <div class="flex-shrink-0">
              <CheckCircleIcon
                v-if="type === 'success'"
                class="h-6 w-6 text-green-400"
                aria-hidden="true"
              />
              <ExclamationTriangleIcon
                v-else-if="type === 'warning'"
                class="h-6 w-6 text-yellow-400"
                aria-hidden="true"
              />
              <XCircleIcon
                v-else-if="type === 'error'"
                class="h-6 w-6 text-red-400"
                aria-hidden="true"
              />
              <InformationCircleIcon
                v-else
                class="h-6 w-6 text-blue-400"
                aria-hidden="true"
              />
            </div>
            <div class="ml-3 w-0 flex-1 pt-0.5">
              <p class="text-sm font-medium text-gray-900">
                {{ title }}
              </p>
              <p class="mt-1 text-sm text-gray-500">
                {{ message }}
              </p>
            </div>
            <div class="ml-4 flex-shrink-0 flex">
              <button
                @click="$emit('close')"
                class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
              >
                <span class="sr-only">Close</span>
                <XMarkIcon class="h-5 w-5" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { 
  CheckCircleIcon, 
  ExclamationTriangleIcon, 
  XCircleIcon, 
  InformationCircleIcon,
  XMarkIcon 
} from '@heroicons/vue/24/outline'
import type { NotificationType } from '@/stores/app'

interface Props {
  type: NotificationType
  message: string
}

const props = defineProps<Props>()
defineEmits<{
  close: []
}>()

const title = computed(() => {
  switch (props.type) {
    case 'success':
      return 'Succès'
    case 'warning':
      return 'Attention'
    case 'error':
      return 'Erreur'
    default:
      return 'Information'
  }
})
</script>